import moment from 'moment';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { queryClient } from '@/src/lib/react-query/react-query';
import { RootState } from '@/src/reducers/types';

import { activityLogsKeys } from './api/getActivityLogs';
import { fileDetailsKeys } from './api/getFileDetails';
import { TreatmentEvents } from './store/fileEntryViewer.treatment.store';

import { InboxEntryStatus } from '../../../types';

export type useTreatmentEventsProps = {
  inboxEntryId: number;
};

export const useTreatmentEvents = ({
  // fileId,
  inboxEntryId,
}: useTreatmentEventsProps): TreatmentEvents => {
  const loggedUser = useSelector((store: RootState) => store.loggedUser);

  const handleActivityLogsUpdated = useCallback(() => {
    queryClient.invalidateQueries([...activityLogsKeys.list(inboxEntryId)]);
  }, [inboxEntryId]);

  const handleTreatmentPublished = useCallback(() => {
    queryClient.setQueryData([...fileDetailsKeys.detail({ fileId: inboxEntryId })], (prev: any) => {
      return {
        ...prev,
        data: {
          ...prev.data,
          'allow-close': {
            allowed: true,
          },
          'allowed-status-changes': [InboxEntryStatus.Closed],
          document: {
            ...prev.data.document,
            recorded: {
              date: moment().format(),
              name: `${loggedUser.data.firstName} ${loggedUser.data.lastName}`,
            },
          },
        },
      };
    });
    handleActivityLogsUpdated();
  }, [inboxEntryId, loggedUser, handleActivityLogsUpdated]);

  return {
    onDraftAction: handleActivityLogsUpdated,
    onTreatmentPublished: handleTreatmentPublished,
  };
};
